import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.search');
import { OnInit, OnDestroy, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-search',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.search/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageSearchComponent implements OnInit, OnDestroy {
    private static SEARCH_STATE_KEY = 'korenet_search_state';
    private static AGENT_SUMMARY_KEY = 'agent_recommendation_summary';
    private static AGENT_RESEARCHERS_KEY = 'agent_recommended_researchers';
    private static AGENT_QUERY_KEY = 'agent_recommendation_query';

    public searchTab: string = 'researcher';
    public searchText: string = '';
    public fuzzySearch: boolean = true;
    public page: number = 1;
    public dump: number = 10;
    public total: number = 0;
    public rows: any[] = [];
    public loading: boolean = false;
    public lastPage: number = 1;

    public sort: string = 'total';
    public order: string = 'DESC';
    public isLoggedIn: boolean = false;
    public bookmarks: any = {};
    public sortOptions: any[] = [
        { value: 'match', label: '매칭성과순' },
        { value: 'total', label: '총 성과물순' },
        { value: 'paper', label: '논문순' },
        { value: 'patent', label: '특허순' },
        { value: 'report', label: '보고서순' }
    ];

    public popoverCardId: string = '';
    public showFilters: boolean = true;
    public showEmptyGuide: boolean = true;

    // 에이전트 추천 결과 모드
    public agentMode: boolean = false;
    public agentSummary: string = '';

    // 패싯 네비게이터
    public facets: any = { orgs: [], keywords: [] };
    public selectedOrgs: string[] = [];
    public selectedKeywords: string[] = [];
    public expandedKeywords: string[] = [];
    public keywordExpansionActive: boolean = false;
    public keywordExpansionSlow: boolean = false;
    public keywordExpansionElapsedSeconds: number = 0;
    public keywordExpansionModelError: string = '';
    public facetLoading: boolean = false;
    public showFacetPanel: boolean = false;
    public openFacetCategory: string = '';
    public showAllOrgs: boolean = false;
    public keywordsLimit: number = 30;

    private agentResultHandler: any = null;
    private facetRequestSeq: number = 0;
    private keywordSearchRequestSeq: number = 0;
    private keywordExpansionTimer: any = null;
    private keywordExpansionStartedAt: number = 0;
    private keywordExpansionPromptDismissed: boolean = false;
    private keywordExpansionModelNotice: string = 'AI 키워드 확장을 완료하지 못했습니다. 일반 키워드 검색으로 다시 시도해 주세요.';

    constructor(@Inject( Service) public service: Service) { }

    private normalizeSearchTab(tab: string | null): string {
        return tab === 'keyword' ? 'keyword' : 'researcher';
    }

    private getDefaultSort(tab: string = this.searchTab): string {
        return tab === 'keyword' ? 'match' : 'total';
    }

    public get activeSortOptions(): any[] {
        return this.searchTab === 'keyword'
            ? this.sortOptions
            : this.sortOptions.filter((option: any) => option.value !== 'match');
    }

    private normalizeSort(sort: string | null, tab: string = this.searchTab): string {
        const defaultSort = this.getDefaultSort(tab);
        const value = String(sort || defaultSort);
        const options = tab === 'keyword'
            ? this.sortOptions
            : this.sortOptions.filter((option: any) => option.value !== 'match');
        return options.some((option: any) => option.value === value) ? value : defaultSort;
    }

    private resetFacetState(clearSelections: boolean = true) {
        if (clearSelections) {
            this.selectedOrgs = [];
            this.selectedKeywords = [];
        }
        this.facets = { orgs: [], keywords: [] };
        this.expandedKeywords = [];
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        this.showFacetPanel = false;
        this.openFacetCategory = '';
        this.facetRequestSeq++;
    }

    private readSavedSearchState(): any {
        try {
            const raw = sessionStorage.getItem(Component.SEARCH_STATE_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }

    private clearSavedSearchState() {
        try {
            sessionStorage.removeItem(Component.SEARCH_STATE_KEY);
        } catch { }
    }

    private hasSavedSearchResults(state: any): boolean {
        return Array.isArray(state?.rows) && (state.rows.length > 0 || Number(state?.total || 0) > 0);
    }

    private savedSearchMatchesUrl(state: any, params: URLSearchParams): boolean {
        if (!this.hasSavedSearchResults(state)) return false;

        const agentIds = params.get('agent_ids');
        if (agentIds) return state.agentMode === true;

        const query = params.get('q');
        if (!query) return true;

        const urlTab = this.normalizeSearchTab(params.get('tab'));
        const urlSort = this.normalizeSort(params.get('sort'), urlTab);
        const urlPage = parseInt(params.get('page') || '1');
        const urlFuzzy = params.get('fuzzy') !== 'false';
        const stateTab = this.normalizeSearchTab(state.searchTab || 'researcher');
        const stateSort = this.normalizeSort(state.sort || null, stateTab);

        return String(state.searchText || '') === query
            && stateTab === urlTab
            && stateSort === urlSort
            && Number(state.page || 1) === urlPage
            && (state.fuzzySearch !== false) === urlFuzzy;
    }

    private restoreSavedSearchState(state: any, restoreResults: boolean = false): boolean {
        if (!state) return false;

        this.searchText = state.searchText || '';
        this.searchTab = this.normalizeSearchTab(state.searchTab || 'researcher');
        this.sort = this.normalizeSort(state.sort || null, this.searchTab);
        this.order = state.order || 'DESC';
        this.page = Number(state.page || 1);
        this.dump = Number(state.dump || this.dump || 10);
        this.fuzzySearch = state.fuzzySearch !== false;
        this.selectedOrgs = this.toStringArray(state.selectedOrgs);
        this.selectedKeywords = this.toStringArray(state.selectedKeywords);
        this.expandedKeywords = this.toStringArray(state.expandedKeywords);
        this.keywordExpansionModelError = String(state.keywordExpansionModelError || '');
        this.agentMode = state.agentMode === true;
        this.agentSummary = String(state.agentSummary || '');
        this.showFilters = state.showFilters !== false;
        this.showAllOrgs = state.showAllOrgs === true;
        this.keywordsLimit = Math.max(30, Number(state.keywordsLimit || 30));
        this.loading = false;
        this.facetLoading = false;
        this.keywordExpansionActive = false;
        this.keywordExpansionSlow = false;
        this.keywordExpansionElapsedSeconds = 0;

        if (!restoreResults || !this.hasSavedSearchResults(state)) {
            return false;
        }

        this.rows = state.rows || [];
        this.total = Number(state.total || this.rows.length || 0);
        this.lastPage = Number(state.lastPage || Math.ceil(this.total / this.dump) || 1);
        this.facets = {
            orgs: Array.isArray(state.facets?.orgs) ? state.facets.orgs : [],
            keywords: Array.isArray(state.facets?.keywords) ? state.facets.keywords : []
        };
        this.mergeCurrentRowsIntoFacets();
        this.showEmptyGuide = this.rows.length === 0 && !this.searchText.trim() && !this.agentMode;
        return true;
    }

    private buildSearchStateSnapshot(): any {
        return {
            searchText: this.searchText,
            searchTab: this.searchTab,
            page: this.page,
            dump: this.dump,
            total: this.total,
            lastPage: this.lastPage,
            sort: this.sort,
            order: this.order,
            fuzzySearch: this.fuzzySearch,
            selectedOrgs: [...this.selectedOrgs],
            selectedKeywords: [...this.selectedKeywords],
            expandedKeywords: [...this.expandedKeywords],
            keywordExpansionModelError: this.keywordExpansionModelError,
            agentMode: this.agentMode,
            agentSummary: this.agentSummary,
            showEmptyGuide: this.showEmptyGuide,
            showFilters: this.showFilters,
            showAllOrgs: this.showAllOrgs,
            keywordsLimit: this.keywordsLimit,
            rows: this.rows || [],
            facets: this.facets || { orgs: [], keywords: [] },
            savedAt: Date.now()
        };
    }

    private saveSearchStateSnapshot() {
        try {
            sessionStorage.setItem(Component.SEARCH_STATE_KEY, JSON.stringify(this.buildSearchStateSnapshot()));
        } catch { }
    }

    public async ngOnInit() {
        await this.service.init();
        const params = new URLSearchParams(location.search);
        this.searchText = params.get('q') || '';
        this.searchTab = this.normalizeSearchTab(params.get('tab'));
        this.sort = this.normalizeSort(params.get('sort'), this.searchTab);
        this.page = parseInt(params.get('page') || '1');
        this.fuzzySearch = params.get('fuzzy') !== 'false';

        // sessionStorage에서 검색 상태 복원 (뒤로가기 시)
        const saved = this.readSavedSearchState();
        const restoreCachedResults = this.savedSearchMatchesUrl(saved, params);
        if (saved && (restoreCachedResults || (!params.get('q') && !params.get('agent_ids')))) {
            this.restoreSavedSearchState(saved, restoreCachedResults);
            this.clearSavedSearchState();
        } else if (saved) {
            this.clearSavedSearchState();
        }

        // 에이전트 결과 ID로 직접 진입
        const agentIds = params.get('agent_ids');
        if (restoreCachedResults) {
            this.showEmptyGuide = this.rows.length === 0 && !this.searchText.trim() && !this.agentMode;
            await this.checkSession();
            const ids = this.rows.map((r: any) => r.researcher_id).filter((id: string) => id);
            await this.checkBookmarks(ids);
            if (!this.agentMode) {
                this.updateUrlParams();
            }
            await this.service.render();
        } else if (agentIds) {
            this.searchTab = 'researcher';
            this.showEmptyGuide = false;
            this.agentSummary = '';
            await this.checkSession();
            await this.loadByIds(agentIds.split(',').map(id => id.trim()).filter(id => id));
            this.agentMode = true;
            await this.service.render();
        } else if (this.searchText.trim()) {
            this.showEmptyGuide = false;
            await this.checkSession();
            if (this.searchTab === 'keyword') {
                await this.loadByKeyword();
                this.loadKeywordFacets();
            } else {
                await this.load();
                this.loadFacets();
            }
            await this.service.render();
        } else {
            await this.checkSession();
            await this.service.render();
        }

        // 챗봇에서 에이전트 결과를 받기 위한 이벤트 리스너
        this.agentResultHandler = async (e: any) => {
            const ids = e.detail?.ids || [];
            if (ids.length > 0) {
                this.searchTab = 'researcher';
                this.agentMode = true;
                this.showEmptyGuide = false;
                this.agentSummary = '';
                await this.loadByIds(ids);
                await this.service.render();
            }
        };
        window.addEventListener('chatbot-agent-results', this.agentResultHandler);
    }

    ngOnDestroy() {
        if (this.agentResultHandler) {
            window.removeEventListener('chatbot-agent-results', this.agentResultHandler);
            this.agentResultHandler = null;
        }
        this.clearKeywordExpansionStatus();
    }

    private getStoredAgentSummary(): string {
        try {
            return sessionStorage.getItem(Component.AGENT_SUMMARY_KEY) || '';
        } catch {
            return '';
        }
    }

    private getStoredAgentResearchers(): any[] {
        try {
            const raw = sessionStorage.getItem(Component.AGENT_RESEARCHERS_KEY) || '[]';
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    }

    private clearStoredAgentContext() {
        try {
            sessionStorage.removeItem(Component.AGENT_SUMMARY_KEY);
            sessionStorage.removeItem(Component.AGENT_RESEARCHERS_KEY);
            sessionStorage.removeItem(Component.AGENT_QUERY_KEY);
        } catch { }
    }

    private getStoredAgentQuery(): string {
        try {
            return sessionStorage.getItem(Component.AGENT_QUERY_KEY) || '';
        } catch {
            return '';
        }
    }

    private looksLikeRawStructuredText(text: string): boolean {
        const value = String(text || '').trim();
        if (!value) return false;
        if (value.startsWith('[') || value.startsWith('{')) return true;
        return value.includes('"researcher_id"') || value.includes('"matched_keywords"') || value.includes('"keyword_match_count"');
    }

    private async refreshAgentSummary() {
        if (!this.agentMode || !this.rows.length) {
            return;
        }

        const storedRows = this.getStoredAgentResearchers();
        const query = this.getStoredAgentQuery() || this.searchText || '';
        const targetRows = (storedRows.length > 0 ? storedRows : this.rows).slice(0, 10);

        try {
            const { code, data } = await wiz.call('generate_agent_summary', {
                message: query,
                researchers: JSON.stringify(targetRows),
            });
            if (code === 200) {
                const summary = String(data?.summary || '').trim();
                if (summary && !this.looksLikeRawStructuredText(summary)) {
                    this.agentSummary = summary;
                    try {
                        sessionStorage.setItem(Component.AGENT_SUMMARY_KEY, summary);
                    } catch { }
                    return;
                }
            }
        } catch { }

        const fallback = this.buildFallbackAgentSummary(targetRows);
        if (fallback) {
            this.agentSummary = fallback;
        }
    }

    private normalizeKeywordList(value: any): string[] {
        if (Array.isArray(value)) {
            return value.map((item: any) => String(item || '').trim()).filter((item: string) => item);
        }
        if (typeof value === 'string') {
            return value
                .split(/[;,|]/)
                .map((item: string) => item.trim())
                .filter((item: string) => item);
        }
        return [];
    }

    private toStringArray(value: any): string[] {
        return this.normalizeKeywordList(value);
    }

    private ensureFacetSelections() {
        if (!Array.isArray(this.selectedOrgs)) {
            this.selectedOrgs = this.toStringArray(this.selectedOrgs);
        }
        if (!Array.isArray(this.selectedKeywords)) {
            this.selectedKeywords = this.toStringArray(this.selectedKeywords);
        }
    }

    private normalizeKeywordTerm(value: any): string {
        return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }

    private uniqueKeywords(keywords: string[]): string[] {
        const seen = new Set<string>();
        return keywords
            .map((keyword: string) => String(keyword || '').trim())
            .filter((keyword: string) => {
                const key = this.normalizeKeywordTerm(keyword);
                if (!key || seen.has(key)) return false;
                seen.add(key);
                return true;
            });
    }

    private buildFacetPayloadFromRows(rows: any[]): any {
        const orgCounts = new Map<string, number>();
        const keywordCounts = new Map<string, any>();

        (rows || []).forEach((row: any) => {
            const orgName = String(row?.org_name || '').trim();
            if (orgName) {
                orgCounts.set(orgName, (orgCounts.get(orgName) || 0) + 1);
            }

            const rowSeen = new Set<string>();
            this.normalizeKeywordList(row?.keyword_kor || row?.keyword).forEach((keyword: string) => {
                const key = this.normalizeKeywordTerm(keyword);
                if (!key || rowSeen.has(key)) return;
                rowSeen.add(key);

                const current = keywordCounts.get(key);
                if (current) {
                    current.count += 1;
                } else {
                    keywordCounts.set(key, { name: keyword, count: 1 });
                }
            });
        });

        return {
            orgs: Array.from(orgCounts.entries())
                .map(([name, count]: [string, number]) => ({ name, count }))
                .sort((a: any, b: any) => b.count - a.count || a.name.localeCompare(b.name)),
            keywords: Array.from(keywordCounts.values())
                .sort((a: any, b: any) => b.count - a.count || a.name.localeCompare(b.name))
        };
    }

    private mergeFacetList(apiItems: any[], rowItems: any[]): any[] {
        const merged = new Map<string, any>();

        (apiItems || []).forEach((item: any) => {
            const name = String(item?.name || '').trim();
            const key = this.normalizeKeywordTerm(name);
            if (!key) return;
            merged.set(key, { name, count: Number(item?.count || 0) || 0 });
        });

        (rowItems || []).forEach((item: any) => {
            const name = String(item?.name || '').trim();
            const key = this.normalizeKeywordTerm(name);
            if (!key) return;
            const count = Number(item?.count || 0) || 0;
            const current = merged.get(key);
            if (current) {
                current.count = Math.max(current.count, count);
            } else {
                merged.set(key, { name, count });
            }
        });

        return Array.from(merged.values())
            .sort((a: any, b: any) => b.count - a.count || a.name.localeCompare(b.name));
    }

    private mergeFacetPayload(apiFacets: any, rows: any[] = this.rows): any {
        const rowFacets = this.buildFacetPayloadFromRows(rows);
        return {
            orgs: this.mergeFacetList(apiFacets?.orgs || [], rowFacets.orgs),
            keywords: this.mergeFacetList(apiFacets?.keywords || [], rowFacets.keywords)
        };
    }

    private mergeCurrentRowsIntoFacets() {
        this.facets = this.mergeFacetPayload(this.facets || { orgs: [], keywords: [] }, this.rows);
    }

    private canReuseExpandedKeywords(): boolean {
        const currentTerm = this.normalizeKeywordTerm(this.searchText);
        return !!currentTerm && this.expandedKeywords.some(
            (keyword: string) => this.normalizeKeywordTerm(keyword) === currentTerm
        ) && this.hasUsefulExpandedKeywords(this.expandedKeywords, currentTerm);
    }

    private hasUsefulExpandedKeywords(keywords: string[], baseTerm: string = this.normalizeKeywordTerm(this.searchText)): boolean {
        if (!baseTerm) return false;
        return this.uniqueKeywords(keywords || []).some(
            (keyword: string) => this.normalizeKeywordTerm(keyword) !== baseTerm
        );
    }

    private clearKeywordExpansionStatus() {
        if (this.keywordExpansionTimer) {
            clearInterval(this.keywordExpansionTimer);
            this.keywordExpansionTimer = null;
        }
        this.keywordExpansionStartedAt = 0;
        this.keywordExpansionElapsedSeconds = 0;
        this.keywordExpansionActive = false;
        this.keywordExpansionSlow = false;
        this.keywordExpansionPromptDismissed = false;
    }

    private clearKeywordExpansionModelError() {
        this.keywordExpansionModelError = '';
    }

    private isModelProblemMessage(message: any): boolean {
        const text = String(message || '').toLowerCase();
        if (!text) return false;
        return [
            'model',
            'llm',
            'ollama',
            'api/chat',
            'not found',
            'notfound',
            'timeout',
            'timed out',
            'connection',
            'refused',
            'unavailable',
            'empty keyword response',
            '모델'
        ].some((marker: string) => text.includes(marker));
    }

    private keywordExpansionErrorFromResponse(data: any): string {
        const message = String(data?.keyword_expansion_error || data?.model_error_message || '').trim();
        if (message) return message;
        if (data?.model_error === true) return this.keywordExpansionModelNotice;
        return '';
    }

    private startKeywordExpansionStatus() {
        this.clearKeywordExpansionStatus();
        this.keywordExpansionActive = true;
        this.keywordExpansionStartedAt = Date.now();
        this.keywordExpansionTimer = setInterval(async () => {
            if (!this.keywordExpansionActive) return;
            this.keywordExpansionElapsedSeconds = Math.floor((Date.now() - this.keywordExpansionStartedAt) / 1000);
            if (this.keywordExpansionElapsedSeconds >= 30 && !this.keywordExpansionPromptDismissed) {
                this.keywordExpansionSlow = true;
            }
            await this.service.render();
        }, 1000);
    }

    public async continueKeywordExpansionWait() {
        this.keywordExpansionPromptDismissed = true;
        this.keywordExpansionSlow = false;
        await this.service.render();
    }

    public async useExactKeywordSearch() {
        if (!this.searchText.trim()) return;
        const requestSeq = ++this.keywordSearchRequestSeq;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.fuzzySearch = false;
        this.expandedKeywords = [];
        this.page = 1;
        await this.service.render();
        await this.loadByKeyword(1, { requestSeq, forceExact: true });
        this.loadKeywordFacets();
    }

    private getRawMatchedKeywords(row: any): string[] {
        return this.normalizeKeywordList(row?.matched_keywords);
    }

    private getKeywordFocusTerms(row: any): string[] {
        const keywords: string[] = [];
        keywords.push(...this.getRawMatchedKeywords(row));
        keywords.push(...this.selectedKeywords);
        const searchKeyword = row?._rendered_search_keyword || this.searchText.trim();
        if (this.searchTab === 'keyword' && searchKeyword) {
            keywords.push(searchKeyword);
        }
        return this.uniqueKeywords(keywords).slice(0, 20);
    }

    private getKeywordFocusMatch(tag: string, row: any): any {
        const tagKey = this.normalizeKeywordTerm(tag);
        const fallback = { priority: 3, index: 999999 };
        if (!tagKey) return fallback;

        const focusTerms = this.getKeywordFocusTerms(row);
        if (focusTerms.length === 0) return fallback;

        for (let i = 0; i < focusTerms.length; i++) {
            if (tagKey === this.normalizeKeywordTerm(focusTerms[i])) {
                return { priority: 0, index: i };
            }
        }
        for (let i = 0; i < focusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(focusTerms[i]);
            if (keywordKey && tagKey.includes(keywordKey)) {
                return { priority: 1, index: i };
            }
        }
        for (let i = 0; i < focusTerms.length; i++) {
            const keywordKey = this.normalizeKeywordTerm(focusTerms[i]);
            if (tagKey.length >= 2 && keywordKey.includes(tagKey)) {
                return { priority: 2, index: i };
            }
        }
        return fallback;
    }

    private getDetailMatchedKeywordTags(row: any): string[] {
        const tags = this._getAllTags(row);
        if (tags.length === 0) return [];

        return tags
            .map((tag: string, index: number) => ({
                tag,
                index,
                match: this.getKeywordFocusMatch(tag, row)
            }))
            .filter((item: any) => item.match.priority < 3)
            .sort((a: any, b: any) => {
                if (a.match.priority !== b.match.priority) return a.match.priority - b.match.priority;
                if (a.match.index !== b.match.index) return a.match.index - b.match.index;
                return a.index - b.index;
            })
            .map((item: any) => item.tag);
    }

    private freezeRenderedMatchedKeywords(rows: any[], searchKeyword: string = this.searchText.trim()) {
        (rows || []).forEach((row: any) => {
            if (!row) return;
            row._rendered_search_keyword = String(searchKeyword || '').trim();
            const detailKeywords = this.getDetailMatchedKeywordTags(row);
            row._rendered_matched_keywords = detailKeywords.length > 0
                ? this.uniqueKeywords(detailKeywords).slice(0, 20)
                : this.getRawMatchedKeywords(row).slice(0, 20);
        });
    }

    public getMatchedKeywords(row: any): string[] {
        if (Array.isArray(row?._rendered_matched_keywords)) {
            return row._rendered_matched_keywords;
        }
        const detailKeywords = this.getDetailMatchedKeywordTags(row);
        if (detailKeywords.length > 0) return this.uniqueKeywords(detailKeywords).slice(0, 20);
        return this.getRawMatchedKeywords(row).slice(0, 20);
    }

    private getResearcherDetailKeywords(row: any): string[] {
        const keywords: string[] = [];
        const matchedKeywords = this.getMatchedKeywords(row);
        const searchKeyword = row?._rendered_search_keyword || this.searchText.trim();

        if (matchedKeywords.length === 0 && this.searchTab === 'keyword' && searchKeyword) {
            keywords.push(searchKeyword);
        }
        keywords.push(...matchedKeywords);
        keywords.push(...this.selectedKeywords);

        return this.uniqueKeywords(keywords).slice(0, 20);
    }

    private buildResearcherDetailUrl(id: string, row: any): string {
        const keywords = this.getResearcherDetailKeywords(row);
        if (keywords.length === 0) return `/researcher/${id}`;

        const params = new URLSearchParams();
        params.set('keywords', keywords.join('|'));
        return `/researcher/${id}?${params.toString()}`;
    }

    public getMatchedKeywordCount(row: any): number {
        const displayCount = this.getMatchedKeywords(row).length;
        if (displayCount > 0) return displayCount;
        return this.toCount(row?.keyword_match_count);
    }

    private toCount(value: any): number {
        const count = Number(value || 0);
        return Number.isFinite(count) ? count : 0;
    }

    public getKeywordPublicationCount(row: any): number {
        const explicitCount = this.toCount(row?.keyword_pub_count);
        if (explicitCount > 0) return explicitCount;
        return this.getKeywordPaperCount(row) + this.getKeywordPatentCount(row) + this.getKeywordReportCount(row);
    }

    public getKeywordPaperCount(row: any): number {
        return this.toCount(row?.keyword_paper_count);
    }

    public getKeywordPatentCount(row: any): number {
        return this.toCount(row?.keyword_patent_count);
    }

    public getKeywordReportCount(row: any): number {
        return this.toCount(row?.keyword_report_count);
    }

    public getRecommendationReason(row: any): string {
        if (!row) return '';

        const reasons: string[] = [];
        const matchedKeywords = this.normalizeKeywordList(row.matched_keywords).slice(0, 3);
        const sharedKeywords = this.normalizeKeywordList(row.shared_keywords).slice(0, 3);
        const keywordPreview = this.normalizeKeywordList(row.keyword_kor || row.keyword).slice(0, 3);

        const keywordPubCount = Number(row.keyword_pub_count || 0);
        const keywordMatchCount = Number(row.keyword_match_count || matchedKeywords.length || 0);
        const paperCount = Number(row.paper_cnt || 0);
        const reportCount = Number(row.report_cnt || 0);
        const patentCount = Number(row.patent_cnt || 0);
        const coauthorPaperCount = Number(row.coauthor_paper_count || 0);
        const similarityScore = Number(row.similarity_score || 0);

        if (matchedKeywords.length > 0) {
            const keywordText = matchedKeywords.join(', ');
            if (keywordPubCount > 0) {
                reasons.push(`${keywordText} 관련 성과가 ${keywordPubCount}건 확인돼 질문 키워드와 직접 연결됩니다.`);
            } else {
                reasons.push(`${keywordText} 등 ${keywordMatchCount}개 핵심 키워드가 질문 주제와 맞닿아 있습니다.`);
            }
        } else if (sharedKeywords.length > 0) {
            const sharedText = sharedKeywords.join(', ');
            if (coauthorPaperCount > 0) {
                reasons.push(`${sharedText} 주제가 겹치고 공동 연구 ${coauthorPaperCount}건이 있어 연관성이 높습니다.`);
            } else {
                const scoreText = similarityScore > 0 ? similarityScore.toFixed(2).replace(/\.00$/, '') : '상당';
                reasons.push(`${sharedText} 주제가 겹치며 유사도 ${scoreText} 수준의 가까운 연구 흐름을 보입니다.`);
            }
        }

        if (paperCount > 0) {
            reasons.push(`관련 분야 논문 ${paperCount}편을 보유해 후속 검토 가치가 높습니다.`);
        } else if (reportCount > 0 || patentCount > 0) {
            const outputs = [];
            if (reportCount > 0) outputs.push(`보고서 ${reportCount}건`);
            if (patentCount > 0) outputs.push(`특허 ${patentCount}건`);
            reasons.push(`${outputs.join(', ')}을 보유한 실무형 연구 이력이 확인됩니다.`);
        } else if (keywordPreview.length > 0) {
            reasons.push(`${keywordPreview.join(', ')} 중심으로 연구를 이어 온 전문가입니다.`);
        }

        return reasons.slice(0, 2).join(' ');
    }

    private buildFallbackAgentSummary(rows: any[]): string {
        const sourceRows = rows || [];
        if (sourceRows.length === 0) return '';

        const keywordCounts = new Map<string, number>();
        let hasDirectMatch = false;
        let hasSimilarity = false;
        let hasNetwork = false;

        for (const row of sourceRows) {
            const matchedKeywords = this.normalizeKeywordList(row?.matched_keywords);
            const sharedKeywords = this.normalizeKeywordList(row?.shared_keywords);
            const previewKeywords = this.normalizeKeywordList(row?.keyword || row?.keyword_kor).slice(0, 2);
            const uniqueKeywords = new Set<string>([...matchedKeywords, ...sharedKeywords, ...previewKeywords]);

            if (matchedKeywords.length > 0 || Number(row?.keyword_pub_count || 0) > 0) {
                hasDirectMatch = true;
            }
            if (sharedKeywords.length > 0 || Number(row?.similarity_score || 0) > 0) {
                hasSimilarity = true;
            }
            if (Number(row?.coauthor_paper_count || 0) > 0) {
                hasNetwork = true;
            }

            uniqueKeywords.forEach((keyword: string) => {
                const normalized = String(keyword || '').trim();
                if (!normalized) return;
                keywordCounts.set(normalized, (keywordCounts.get(normalized) || 0) + 1);
            });
        }

        const topKeywords = Array.from(keywordCounts.entries())
            .sort((left, right) => {
                if (right[1] !== left[1]) return right[1] - left[1];
                return left[0].localeCompare(right[0], 'ko');
            })
            .slice(0, 3)
            .map(([keyword]) => keyword);

        const overview = topKeywords.length > 0
            ? `추천된 연구자들은 ${topKeywords.join(', ')}을 중심으로 질문 주제와 맞닿은 연구 경험을 보여 함께 추천되었습니다.`
            : '추천된 연구자들은 질문 주제와 맞닿은 연구 경험과 전문성을 공통으로 보여 함께 추천되었습니다.';

        const evidence = hasDirectMatch && (hasSimilarity || hasNetwork)
            ? '직접적인 주제 적합성에 더해 유사한 연구 흐름과 협업 맥락도 함께 확인돼, 한 방향이 아니라 여러 근거에서 검토 가치가 높은 후보들입니다.'
            : hasDirectMatch
                ? '관련 성과와 연구 키워드에서 공통성이 확인돼 우선 검토할 후보군으로 정리했습니다.'
                : hasSimilarity || hasNetwork
                    ? '세부 주제의 연결성과 연구 흐름의 유사성이 확인돼 함께 검토할 가치가 있는 후보들입니다.'
                    : '질문과 연결되는 연구 배경과 전문 주제가 겹쳐 종합 추천 대상으로 정리했습니다.';

        return `${overview} ${evidence}`.trim();
    }

    public getAgentSummaryText(): string {
        if (!this.agentMode) return '';

        if (this.agentSummary && !this.looksLikeRawStructuredText(this.agentSummary)) {
            return this.agentSummary;
        }

        const storedRows = this.getStoredAgentResearchers();
        return this.buildFallbackAgentSummary(storedRows.length > 0 ? storedRows : this.rows);
    }

    private scoreComponentMeta(): any[] {
        return [
            { key: 'paper', weightKey: 'paper_count_weight', label: '논문 수' },
            { key: 'report', weightKey: 'report_count_weight', label: '보고서 수' },
            { key: 'recency', weightKey: 'recent_count_weight', label: '최근 3년' },
            { key: 'patent', weightKey: 'patent_count_weight', label: '특허 수' },
            { key: 'focus', weightKey: 'focus_score_weight', label: '집중도' },
            { key: 'publication', weightKey: 'publication_score_weight', label: '성과물 점수' },
            { key: 'journal_level', weightKey: 'journal_level_score_weight', label: '학술지 수준' },
        ];
    }

    private numberValue(value: any, fallback: number = 0): number {
        const number = Number(value);
        return Number.isFinite(number) ? number : fallback;
    }

    private getScoreBreakdown(row: any): any {
        return row?.score_breakdown || {};
    }

    private getScoreWeights(row: any): any {
        const breakdown = this.getScoreBreakdown(row);
        return breakdown.weights_applied || row?.weights_applied || {};
    }

    private getNormalizedComponents(row: any): any {
        const breakdown = this.getScoreBreakdown(row);
        return breakdown.normalized_score_components || row?.normalized_score_components || {};
    }

    public formatScore(value: any): string {
        const number = Number(value);
        if (!Number.isFinite(number)) return '0';
        if (Math.abs(number) >= 100) return number.toFixed(0);
        if (Math.abs(number) >= 10) return number.toFixed(2).replace(/\.?0+$/, '');
        return number.toFixed(4).replace(/\.?0+$/, '');
    }

    public hasScoreEvidence(row: any): boolean {
        if (!this.agentMode || !row) return false;
        const breakdown = this.getScoreBreakdown(row);
        const hasScore = row.score !== undefined && row.score !== null && Number(row.score) > 0;
        const hasWeighted = row.weighted_score !== undefined && row.weighted_score !== null && Number(row.weighted_score) > 0;
        const hasComponents = Object.keys(this.getNormalizedComponents(row)).length > 0
            || Object.keys(row.score_components || {}).length > 0
            || Object.keys(breakdown.score_components || {}).length > 0;
        return hasScore || hasWeighted || hasComponents;
    }

    public hasAgentEvidence(): boolean {
        return this.agentMode && (this.rows || []).some((row: any) => this.hasScoreEvidence(row));
    }

    public getAgentEvidenceRows(): any[] {
        return (this.rows || []).filter((row: any) => this.hasScoreEvidence(row)).slice(0, 5);
    }

    public getAppliedWeightChips(row: any = null): any[] {
        const target = row || this.getAgentEvidenceRows()[0];
        if (!target) return [];
        const weights = this.getScoreWeights(target);
        return this.scoreComponentMeta()
            .map((meta: any) => ({
                label: meta.label,
                value: this.numberValue(weights[meta.weightKey], NaN)
            }))
            .filter((item: any) => Number.isFinite(item.value))
            .map((item: any) => ({
                label: item.label,
                text: `${Math.round(item.value * 100)}%`
            }));
    }

    public getAgentMatchedKeywordPreview(): string[] {
        const seen = new Set<string>();
        const keywords: string[] = [];
        (this.rows || []).forEach((row: any) => {
            this.getMatchedKeywords(row).forEach((keyword: string) => {
                const key = this.normalizeKeywordTerm(keyword);
                if (!key || seen.has(key)) return;
                seen.add(key);
                keywords.push(keyword);
            });
        });
        return keywords.slice(0, 12);
    }

    public getScoreFormula(row: any): string {
        if (!this.hasScoreEvidence(row)) return '';
        const breakdown = this.getScoreBreakdown(row);
        const finalScore = this.numberValue(row?.score, this.numberValue(breakdown.score, 0));
        const weightedScore = this.numberValue(row?.weighted_score, this.numberValue(breakdown.weighted_score, 0));
        const keywordWeight = this.numberValue(row?.keyword_weight, this.numberValue(breakdown.keyword_weight, 1));
        const keywordPublicationScore = this.numberValue(
            row?.keyword_publication_score,
            this.numberValue(breakdown.keyword_publication_score, 0)
        );

        if (finalScore > 0 && weightedScore > 0) {
            return `최종점수 ${this.formatScore(finalScore)} = 사용자 가중점수 ${this.formatScore(weightedScore)} × 키워드 동시매칭 ${this.formatScore(keywordWeight)}`;
        }
        if (finalScore > 0 && keywordPublicationScore > 0) {
            return `최종점수 ${this.formatScore(finalScore)} = 키워드 성과점수 ${this.formatScore(keywordPublicationScore)} × 키워드 동시매칭 ${this.formatScore(keywordWeight)}`;
        }
        return '';
    }

    public getAgentSortBasisText(): string {
        if (!this.hasAgentEvidence()) {
            return '현재 목록은 AI 에이전트가 전달한 추천 순서를 유지합니다.';
        }
        return '정렬은 최종점수가 높은 순서를 기준으로 하며, 최종점수는 사용자 가중점수에 키워드 동시매칭 가중치를 곱해 계산합니다.';
    }

    public getScoreComponentRows(row: any): any[] {
        if (!this.hasScoreEvidence(row)) return [];
        const weights = this.getScoreWeights(row);
        const normalized = this.getNormalizedComponents(row);
        return this.scoreComponentMeta()
            .map((meta: any) => {
                const weight = this.numberValue(weights[meta.weightKey], NaN);
                const relative = this.numberValue(normalized[meta.key], 0);
                const contribution = Number.isFinite(weight) ? weight * relative : 0;
                return {
                    label: meta.label,
                    weight,
                    relative,
                    contribution,
                    weightText: Number.isFinite(weight) ? `${Math.round(weight * 100)}%` : '-',
                    relativeText: this.formatScore(relative),
                    contributionText: this.formatScore(contribution),
                };
            })
            .filter((item: any) => Number.isFinite(item.weight) || item.relative > 0 || item.contribution > 0);
    }

    public getScoreEvidenceText(row: any): string {
        const keywords = this.getMatchedKeywords(row).slice(0, 5);
        const keywordText = keywords.length > 0 ? `매칭 키워드 ${keywords.join(', ')}` : '';
        const formula = this.getScoreFormula(row);
        return [formula, keywordText].filter((part: string) => part).join(' · ');
    }

    private mergeAgentRows(rows: any[], orderedIds: string[] = []): any[] {
        const storedRows = this.getStoredAgentResearchers();
        const lookup = new Map<string, any>();
        const order = new Map<string, number>();

        orderedIds.forEach((id: string, index: number) => {
            if (id) order.set(id, index);
        });

        storedRows.forEach((row: any, index: number) => {
            const key = row.researcher_id || row.id || '';
            if (!key) return;
            lookup.set(key, row);
            if (!order.has(key)) {
                order.set(key, index);
            }
        });

        const merged = (rows || []).map((row: any) => {
            const key = row.researcher_id || row.id || '';
            const saved = key ? (lookup.get(key) || {}) : {};
            const combined = { ...saved, ...row };
            combined.ai_recommended = true;
            combined.recommendation_reason = this.getRecommendationReason(combined);
            return combined;
        });

        if (order.size > 0) {
            merged.sort((left: any, right: any) => {
                const leftKey = left.researcher_id || left.id || '';
                const rightKey = right.researcher_id || right.id || '';
                const leftOrder = order.has(leftKey) ? (order.get(leftKey) as number) : Number.MAX_SAFE_INTEGER;
                const rightOrder = order.has(rightKey) ? (order.get(rightKey) as number) : Number.MAX_SAFE_INTEGER;
                return leftOrder - rightOrder;
            });
        }

        return merged;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        if (this.popoverCardId) {
            this.popoverCardId = '';
            this.service.render();
        }
        if (this.showFacetPanel || this.openFacetCategory) {
            this.showFacetPanel = false;
            this.openFacetCategory = '';
            this.service.render();
        }
    }

    private updateUrlParams() {
        const params = new URLSearchParams();
        if (this.searchText) params.set('q', this.searchText);
        if (this.searchTab !== 'researcher') params.set('tab', this.searchTab);
        if (this.sort !== this.getDefaultSort()) params.set('sort', this.sort);
        if (!this.fuzzySearch) params.set('fuzzy', 'false');
        if (this.page > 1) params.set('page', String(this.page));
        const qs = params.toString();
        const url = '/search' + (qs ? '?' + qs : '');
        history.replaceState(null, '', url);
    }

    // ── 패싯 네비게이터 ──

    public async loadFacets() {
        if (!this.searchText || (this.searchTab !== 'researcher')) return;
        const requestSeq = ++this.facetRequestSeq;
        const targetText = this.searchText;
        const targetFuzzy = this.fuzzySearch;
        this.facetLoading = true;
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        try {
            const { code, data } = await wiz.call("facets", {
                text: targetText,
                fuzzy: targetFuzzy ? 'true' : 'false'
            });
            if (code === 200 && requestSeq === this.facetRequestSeq
                && this.searchTab === 'researcher'
                && this.searchText === targetText
                && this.fuzzySearch === targetFuzzy) {
                this.facets = this.mergeFacetPayload({
                    orgs: data.orgs || [],
                    keywords: data.keywords || []
                });
            }
        } catch (e) { }
        if (requestSeq === this.facetRequestSeq) {
            this.facetLoading = false;
            await this.service.render();
        }
    }

    public isOrgSelected(orgName: string): boolean {
        this.ensureFacetSelections();
        return this.selectedOrgs.includes(orgName);
    }

    public isKeywordSelected(keyword: string): boolean {
        this.ensureFacetSelections();
        return this.selectedKeywords.includes(keyword);
    }

    public async toggleFacetOrg(orgName: string) {
        this.ensureFacetSelections();
        const idx = this.selectedOrgs.indexOf(orgName);
        if (idx >= 0) {
            this.selectedOrgs.splice(idx, 1);
        } else {
            this.selectedOrgs.push(orgName);
        }
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1);
        } else {
            await this.load(1);
        }
    }

    public async toggleFacetKeyword(keyword: string) {
        this.ensureFacetSelections();
        const idx = this.selectedKeywords.indexOf(keyword);
        if (idx >= 0) {
            this.selectedKeywords.splice(idx, 1);
        } else {
            this.selectedKeywords.push(keyword);
        }
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1);
        } else {
            await this.load(1);
        }
    }

    public async clearFacets() {
        this.selectedOrgs = [];
        this.selectedKeywords = [];
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1);
        } else {
            await this.load(1);
        }
    }

    public async toggleFacetPanel(event: Event) {
        event.stopPropagation();
        this.showFacetPanel = !this.showFacetPanel;
        await this.service.render();
    }

    public async toggleFacetCategory(event: Event, category: string) {
        event.stopPropagation();
        this.openFacetCategory = this.openFacetCategory === category ? '' : category;
        await this.service.render();
    }

    public get hasFacetFilters(): boolean {
        this.ensureFacetSelections();
        return this.selectedOrgs.length > 0 || this.selectedKeywords.length > 0;
    }

    public get hasFacetData(): boolean {
        return this.facets.orgs.length > 0 || this.facets.keywords.length > 0;
    }

    public get visibleOrgs(): any[] {
        return this.showAllOrgs ? this.facets.orgs : this.facets.orgs.slice(0, 10);
    }

    public get visibleKeywords(): any[] {
        return this.facets.keywords.slice(0, this.keywordsLimit);
    }

    public get hasMoreKeywords(): boolean {
        return this.facets.keywords.length > this.keywordsLimit;
    }

    public async toggleShowAllOrgs() {
        this.showAllOrgs = !this.showAllOrgs;
        await this.service.render();
    }

    public async showMoreKeywords() {
        this.keywordsLimit += 30;
        await this.service.render();
    }

    public async collapseKeywords() {
        this.keywordsLimit = 30;
        await this.service.render();
    }

    // ── 검색/로딩 ──

    public async loadByIds(ids: string[]) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.loading = true;
        this.agentMode = true;
        this.agentSummary = '';
        await this.service.render();

        const { code, data } = await wiz.call("search_by_ids", {
            ids: ids.join(',')
        });

        if (code === 200) {
            this.rows = this.mergeAgentRows(data.rows || [], ids);
            this.total = data.total || this.rows.length;
            this.lastPage = 1;
            this.page = 1;
            const rids = this.rows.map((r: any) => r.researcher_id).filter((id: string) => id);
            await this.checkBookmarks(rids);
            await this.refreshAgentSummary();
        }
        this.loading = false;
        await this.service.render();
    }

    public async clearAgentMode() {
        this.agentMode = false;
        this.agentSummary = '';
        this.rows = [];
        this.total = 0;
        this.clearStoredAgentContext();
        this.updateUrlParams();
        await this.load();
        await this.loadFacets();
    }

    public async load(page: number = this.page) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.loading = true;
        this.page = page;
        this.agentMode = false;
        await this.service.render();

        const params: any = {
            text: this.searchText,
            search_type: 'name',
            page: this.page,
            dump: this.dump,
            sort: this.sort,
            order: this.order,
            fuzzy: this.fuzzySearch ? 'true' : 'false'
        };

        // 패싯 필터 적용
        if (this.selectedOrgs.length > 0) {
            params.facet_orgs = this.selectedOrgs.join('|');
        }
        if (this.selectedKeywords.length > 0) {
            params.facet_keywords = this.selectedKeywords.join('|');
        }

        const { code, data } = await wiz.call("search", params);

        if (code === 200) {
            this.rows = data.rows;
            this.total = data.total;
            this.lastPage = Math.ceil(this.total / this.dump) || 1;
            const ids = this.rows.map((r: any) => r.researcher_id).filter((id: string) => id);
            await this.checkBookmarks(ids);
            this.mergeCurrentRowsIntoFacets();
        }
        this.loading = false;
        this.updateUrlParams();
        await this.service.render();
    }

    public async loadByKeyword(page: number = this.page, options: any = {}) {
        const requestSeq = options.requestSeq || ++this.keywordSearchRequestSeq;
        const targetFuzzy = options.forceExact ? false : this.fuzzySearch;
        this.loading = true;
        this.page = page;
        this.agentMode = false;
        this.clearKeywordExpansionModelError();

        const params: any = {
            keyword: this.searchText,
            page: this.page,
            dump: this.dump,
            sort: this.sort,
            order: this.order,
            fuzzy: targetFuzzy ? 'true' : 'false'
        };

        if (targetFuzzy && this.expandedKeywords.length > 0 && this.canReuseExpandedKeywords()) {
            params.expanded_keywords = JSON.stringify(this.expandedKeywords);
        }

        if (this.selectedOrgs.length > 0) {
            params.facet_orgs = this.selectedOrgs.join('|');
        }
        if (this.selectedKeywords.length > 0) {
            params.facet_keywords = this.selectedKeywords.join('|');
        }

        if (targetFuzzy && !params.expanded_keywords) {
            this.startKeywordExpansionStatus();
        } else {
            this.clearKeywordExpansionStatus();
        }
        await this.service.render();

        try {
            const { code, data } = await wiz.call("keyword_search", params);

            if (requestSeq !== this.keywordSearchRequestSeq) {
                return;
            }

            if (code === 200) {
                const nextRows = data.rows || [];
                const nextTotal = data.total || 0;
                const nextExpandedKeywords = targetFuzzy
                    ? this.uniqueKeywords(this.normalizeKeywordList(data.expanded_keywords || []))
                    : [];
                const ids = nextRows.map((r: any) => r.researcher_id).filter((id: string) => id);
                this.freezeRenderedMatchedKeywords(nextRows, params.keyword);
                await this.checkBookmarks(ids);
                if (requestSeq !== this.keywordSearchRequestSeq) {
                    return;
                }
                this.rows = nextRows;
                this.total = nextTotal;
                this.expandedKeywords = nextExpandedKeywords;
                this.keywordExpansionModelError = targetFuzzy ? this.keywordExpansionErrorFromResponse(data) : '';
                this.lastPage = Math.ceil(this.total / this.dump) || 1;
                this.mergeCurrentRowsIntoFacets();
            } else if (targetFuzzy && this.isModelProblemMessage(data?.message || data?.error)) {
                this.keywordExpansionModelError = this.keywordExpansionModelNotice;
            }
        } catch (e) {
            if (targetFuzzy && this.isModelProblemMessage(e?.message || e)) {
                this.keywordExpansionModelError = this.keywordExpansionModelNotice;
            }
        } finally {
            if (requestSeq === this.keywordSearchRequestSeq) {
                this.loading = false;
                this.clearKeywordExpansionStatus();
                this.updateUrlParams();
                await this.service.render();
            }
        }
    }

    public async loadKeywordFacets() {
        if (!this.searchText || this.searchTab !== 'keyword') return;
        const requestSeq = ++this.facetRequestSeq;
        const targetText = this.searchText;
        const targetFuzzy = this.fuzzySearch;
        this.facetLoading = true;
        this.showAllOrgs = false;
        this.keywordsLimit = 30;
        try {
            const params: any = {
                keyword: targetText,
                fuzzy: targetFuzzy ? 'true' : 'false'
            };
            if (targetFuzzy && this.expandedKeywords.length > 0 && this.canReuseExpandedKeywords()) {
                params.expanded_keywords = JSON.stringify(this.expandedKeywords);
            }
            const { code, data } = await wiz.call("keyword_facets", params);
            if (code === 200 && requestSeq === this.facetRequestSeq
                && this.searchTab === 'keyword'
                && this.searchText === targetText
                && this.fuzzySearch === targetFuzzy) {
                this.facets = this.mergeFacetPayload({
                    orgs: data.orgs || [],
                    keywords: data.keywords || []
                });
                if (targetFuzzy && data.expanded_keywords) {
                    const facetExpandedKeywords = this.uniqueKeywords(this.normalizeKeywordList(data.expanded_keywords || []));
                    if (this.hasUsefulExpandedKeywords(facetExpandedKeywords, this.normalizeKeywordTerm(targetText))) {
                        this.expandedKeywords = facetExpandedKeywords;
                    }
                }
                const facetModelError = this.keywordExpansionErrorFromResponse(data);
                if (targetFuzzy && facetModelError) {
                    this.keywordExpansionModelError = facetModelError;
                }
            }
        } catch (e) { }
        if (requestSeq === this.facetRequestSeq) {
            this.facetLoading = false;
            await this.service.render();
        }
    }

    public async onSearch() {
        if (!this.searchText.trim()) {
            this.keywordSearchRequestSeq++;
            this.clearKeywordExpansionStatus();
            this.clearKeywordExpansionModelError();
            this.rows = [];
            this.total = 0;
            this.loading = false;
            this.showEmptyGuide = true;
            await this.service.render();
            return;
        }
        this.showEmptyGuide = false;
        this.page = 1;
        this.resetFacetState(true);
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1);
            this.loadKeywordFacets();
        } else {
            await this.load(1);
            this.loadFacets();
        }
    }

    public async changeTab(tab: string) {
        this.keywordSearchRequestSeq++;
        this.clearKeywordExpansionStatus();
        this.clearKeywordExpansionModelError();
        this.searchTab = this.normalizeSearchTab(tab);
        this.sort = this.getDefaultSort(this.searchTab);
        this.page = 1;
        this.rows = [];
        this.total = 0;
        this.loading = false;
        this.agentMode = false;
        this.resetFacetState(true);
        this.fuzzySearch = true;
        this.updateUrlParams();
        await this.service.render();
    }

    public async changeSort(sortValue: string) {
        this.sort = this.normalizeSort(sortValue);
        this.page = 1;
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(1);
        } else {
            await this.load(1);
        }
    }

    public async toggleFilters() {
        this.showFilters = !this.showFilters;
        await this.service.render();
    }

    public goResearcher(id: string, row: any = null) {
        // 검색 상태를 sessionStorage에 저장 (뒤로가기 시 복원용)
        this.saveSearchStateSnapshot();
        this.service.href(this.buildResearcherDetailUrl(id, row));
    }

    public async toggleFuzzySearch() {
        this.fuzzySearch = !this.fuzzySearch;
        await this.service.render();
    }

    public async pageMove(page: number) {
        if (this.searchTab === 'keyword') {
            await this.loadByKeyword(page);
        } else {
            await this.load(page);
        }
    }

    public _getAllTags(row: any): string[] {
        const fields = row?.keyword_kor;
        if (!fields) return [];
        return fields.split(/[;|]/).map((f: string) => f.trim()).filter((f: string) => f);
    }

    public getVisibleTags(row: any): string[] {
        return this._getAllTags(row).slice(0, 3);
    }

    public getExtraTagCount(row: any): number {
        const all = this._getAllTags(row);
        return Math.max(0, all.length - 3);
    }

    public isPopoverOpen(researcherId: string): boolean {
        return this.popoverCardId === researcherId;
    }

    public async togglePopover(event: Event, researcherId: string) {
        event.stopPropagation();
        if (this.popoverCardId === researcherId) {
            this.popoverCardId = '';
        } else {
            this.popoverCardId = researcherId;
        }
        await this.service.render();
    }

    public getFieldTags(fields: string): string[] {
        if (!fields) return [];
        return fields.split(/[;|]/).map(f => f.trim()).filter(f => f).slice(0, 3);
    }

    public getInitial(name: string): string {
        if (!name) return '?';
        return name.charAt(0);
    }

    public async checkSession() {
        try {
            const { code, data } = await wiz.call("check_session");
            if (code === 200 && data.loggedIn) {
                this.isLoggedIn = true;
            }
        } catch (e) { }
    }

    public async checkBookmarks(ids: string[]) {
        if (!this.isLoggedIn || ids.length === 0) return;
        const { code, data } = await wiz.call("check_bookmarks", { ids: ids.join(',') });
        if (code === 200) {
            this.bookmarks = data;
        }
    }

    public async toggleBookmark(event: Event, researcherId: string) {
        event.stopPropagation();
        if (!this.isLoggedIn) return;
        const { code, data } = await wiz.call("toggle_bookmark", { researcher_id: researcherId });
        if (code === 200) {
            this.bookmarks[researcherId] = data.bookmarked;
        }
        await this.service.render();
    }
}

export default PageSearchComponent;